const STATUSES = ["진행중", "완료", "지연"];
export function dashboardOrderQuery(card, date) {
  const query = { status: "", archived: "false", startDate: "", endDate: "", brandClientId: "", search: "", sort: "desc" };
  if (card === "progress") query.status = "진행중";
  if (card === "attention") query.status = "지연";
  if (card === "completed") query.status = "완료";
  if (card === "today") query.startDate = query.endDate = date;
  if (card === "month") {
    query.startDate = `${date.slice(0, 7)}-01`;
    const [year, month] = date.split("-").map(Number);
    query.endDate = new Date(Date.UTC(year, month, 0)).toISOString().slice(0, 10);
  }
  return query;
}

export function buyerOrderQueryUrl(query) {
  const params = new URLSearchParams({ view: "dashboard", status: query.status || "all" });
  if (query.startDate) params.set("from", query.startDate);
  if (query.endDate) params.set("to", query.endDate);
  return `/history?${params.toString()}`;
}

export function readBuyerOrderEntry(location) {
  const params = new URLSearchParams(location.search || "");
  if (location.pathname !== "/history" || params.get("view") !== "dashboard") return null;
  const status = params.get("status");
  const validDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || "") ? value : "";
  return { ...dashboardOrderQuery("all", ""), status: STATUSES.includes(status) ? status : "",
    startDate: validDate(params.get("from")), endDate: validDate(params.get("to")) };
}

export function orderQueryMatches(a, b) {
  return ["status", "archived", "startDate", "endDate", "brandClientId", "search", "sort"]
    .every(key => String(a?.[key] || "") === String(b?.[key] || ""));
}
